import Splide from '@splidejs/splide'

export default () => {
    const sliders = document.querySelectorAll('.splide');
    sliders.forEach(slider => {
        new Splide(slider, {
            type: 'loop',
            gap: 0,
            pagination: false,
            autoplay: false,
            interval: 6000
        }).mount();
    });
}